<div class="topbar campaign clearfix" style="position: static;">

  <div class="logo-picto">
    <a routerLink="/">
      <img class="logo-picto" src="assets/layout/images/logo-picto.png" alt="" srcset="assets/layout/images/logo-picto@2x.png 2x, assets/layout/images/logo-picto@3x.png 3x">
    </a>
  </div>

  <div id="topbar-icons" class="animated">
    <span *ngIf="step < 4" class="topbar-search" [ngClass]="{ 'error-text': campaignNameError || campaignNameExists }">
      <input  pInputText type="text" placeholder="{{ 'campaign.campaignName' | translate }}" [(ngModel)]="campaign.name"/>
      <span class="topbar-search-icon fa fa-pencil"></span>
    </span>
    <h1 *ngIf="step > 3" style="display: inline; line-height: 50px;">{{ campaign.name }}</h1>

    <div class="icon-right">
      <a routerLink="/support" target="_blank">
        <span class="topbar-campaign-icon fa fa-life-ring animated swing"></span>
        <span class="topbar-campaign-item-text">{{ 'campaign.support' | translate }}</span>
      </a>

      <button *ngIf="step == 3 || step == 5" pButton type="button" class="SaveExit" label="{{ 'campaign.saveButton' | translate }}" (click)="saveExit($event)" [disabled]="saveDisabled"></button>
      <button *ngIf="step == 1 || step == 2 || step == 4" pButton type="button" class="SaveExit" label="{{ 'campaign.exitButton' | translate }}" (click)="saveExit($event)"></button>
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/header/campaign-header.html